exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*used in dashboard only - navigation bar*/\nnav {\n  background-color: #ffffff;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n/*used in dashboard only - logout button*/\n#back {\n  color: #000000;\n}\n.body {\n  background-color: #efefef;\n  min-height: 100vh;\n}\nli {\n  color: #000000;\n}\n/*used in dashboard only - table displaying lessons*/\n.choices {\n  background-color: #ffffff;\n  border: #d3d3d3 solid 1px;\n}\n/*used in dashboard only - table cell*/\n.choice {\n  padding: 10px;\n}\n/*used in dashboard only - enter lesson buttons*/\nbutton {\n  width: 100%;\n  background-color: #12bc54;\n  border: #318e55 solid 0px;\n  padding: 5px;\n  /*border-radius: 3px;\n  margin: 10px;*/\n  color: #ffffff;\n  -webkit-transition: background-color 0.5s;\n  transition: background-color 0.5s;\n}\nbutton:hover {\n  background-color: #11d64c;\n  -webkit-transition: background-color 0.5s;\n  transition: background-color 0.5s;\n}\n/*used in dashboard only - enter lesson buttons*/\nbutton:disabled {\n  background-color: #ffffff;\n  border: #d3d3d3 solid 1px;\n  color: #d3d3d3;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/HirdayGupta/Documents/UCLA/SB18/aslearn/src/app/lesson-p1/lesson-p1.component.css
// module id = ../../../../../src/app/lesson-p1/lesson-p1.component.css
// module chunks = main